import { z } from 'zod';

import {
  TaxForecastProfileFamilySituation,
  TaxForecastProfileTaxCalculationMode,
} from '__generated__/GQL';
import zodLocales from 'common/zod/locales';

export const taxTypeSchema = z.discriminatedUnion('taxCalculationMode', [
  z.object({
    additionalHouseholdRevenue: z
      .union([
        z
          .number({
            invalid_type_error: zodLocales.errors.amount,
          })
          .nonnegative(zodLocales.errors.positive),
        z.nan(),
      ])
      .nullable(),
    familySituation: z.nativeEnum(TaxForecastProfileFamilySituation),
    isSingleParent: z.boolean(),
    numberOfChildren: z
      .union([
        z
          .number({
            invalid_type_error: zodLocales.errors.amount,
          })
          .int(zodLocales.errors.integer)
          .nonnegative(zodLocales.errors.positive),
        z.nan(),
      ])
      .nullable(),
    taxCalculationMode: z.literal(
      TaxForecastProfileTaxCalculationMode.Standard,
    ),
  }),
  z.object({
    customRate: z
      .union([
        z
          .number({
            invalid_type_error: zodLocales.errors.amount,
          })
          .nonnegative(zodLocales.errors.positive),
        z.nan(),
      ])

      .nullable(),
    taxCalculationMode: z.literal(TaxForecastProfileTaxCalculationMode.Custom),
  }),
  z.object({
    taxCalculationMode: z.literal(TaxForecastProfileTaxCalculationMode.Neutral),
  }),
]);

export type TaxTypeSchema = z.infer<typeof taxTypeSchema>;

export type PersonalizedTaxTypeSchema = z.infer<typeof taxTypeSchema> & {
  taxCalculationMode: TaxForecastProfileTaxCalculationMode.Custom;
};

export type NeutralTaxTypeSchema = z.infer<typeof taxTypeSchema> & {
  taxCalculationMode: TaxForecastProfileTaxCalculationMode.Neutral;
};

export type StandardTaxTypeSchema = z.infer<typeof taxTypeSchema> & {
  taxCalculationMode: TaxForecastProfileTaxCalculationMode.Standard;
};
